import {Item} from '@radix-ui/react-toggle-group'
import styled, {css} from 'styled-components'

export const StyledRadioBoxItem = styled(Item)<{$hasError?: boolean}>(
    ({theme: {palette, spacing, typography, shadows, transition}, $hasError = false}) => css`
        ${typography.textSm};
        cursor: pointer;
        height: fit-content;
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        background: ${palette.neutral.white};
        white-space: nowrap;
        outline: 1px solid ${$hasError ? palette.danger['300'] : palette.neutral['300']};
        border-radius: 8px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        font-weight: 500;
        color: ${palette.neutral['500']};
        transition: ${transition};
        box-shadow: ${shadows.sm};
        width: 100%;
        white-space: normal;

        &:hover {
            outline: 1px solid ${palette.primary['300']};
            box-shadow: ${`${shadows.sm}, 0px 0px 0px 4px ${palette.primary['100']}`};
        }

        ${!$hasError &&
        css`
            &[data-state='on']:not(:disabled) {
                outline-color: ${palette.primary['500']};
                box-shadow: none;
                & > input {
                    background: ${palette.primary['500']};
                    content: ${`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2' viewBox='0 0 6 6' fill='none'%3E%3Ccircle cx='3' cy='3' r='3' fill='${palette.neutral.white.replace('#', '%23')}'/%3E%3C/svg%3E");`};
                }
            }
        `}

        &:disabled {
            background: ${palette.neutral['100']};
            color: ${palette.neutral['400']};
            cursor: not-allowed;
            & > input {
                background: transparent;
            }
        }

        &:hover:not(:has(input:disabled)) {
            outline: 1px solid ${$hasError ? palette.danger['500'] : palette.primary['300']};
            box-shadow: ${`${shadows.sm}, 0px 0px 0px 4px ${$hasError ? palette.danger['100'] : palette.primary['100']}`};
        }
    `
)

export const StyledRadioBoxItemInput = styled.input(
    ({theme: {palette, spacing, transition}}) => css`
        flex: none;
        background-color: ${palette.neutral.white};
        width: 20px;
        height: 20px;
        padding: ${spacing * 1.5}px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${palette.neutral['300']};
        transition: ${transition};

        &[data-state='on'] {
            outline-color: ${palette.primary['500']};
            & > input {
                background: ${palette.primary['500']};
                content: ${`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2' viewBox='0 0 6 6' fill='none'%3E%3Ccircle cx='3' cy='3' r='3' fill='${palette.neutral.white.replace('#', '%23')}'/%3E%3C/svg%3E");`};
            }
        }

        &[data-state='on']:disabled {
            background: ${palette.neutral['100']};
            border: 1px solid ${palette.neutral['300']};
            cursor: not-allowed;
            content: ${`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2' viewBox='0 0 6 6' fill='none'%3E%3Ccircle cx='3' cy='3' r='3' fill='${palette.neutral['400'].replace('#', '%23')}'/%3E%3C/svg%3E");`};
        }
    `
)
